import Datepicker, { DateValueType } from 'react-tailwindcss-datepicker';

type InputDateProps = {
  label: string;
  value: DateValueType;
  required?: boolean;
  description?: string;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  onChange: (value: DateValueType, e?: HTMLInputElement | null | undefined) => void;
};

const russianLocale = {
  days: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  months: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],
  shortcuts: {
    today: 'Сегодня',
    yesterday: 'Вчера',
    past: (period: string) => `Последние ${period} дней`,
    currentMonth: 'Текущий месяц',
    pastMonth: 'Прошлый месяц',
  },
};

function InputDate({ label, value, required, description, disabled = false, minDate, maxDate, onChange }: InputDateProps) {
  return (
    <div className='flex flex-col gap-1'>
      <label className='text-black text-base flex justify-between items-center'>
        {label}
        {required && <span className='text-[#BA0C2F]'>*</span>}
      </label>

      <Datepicker
        inputClassName={`relative transition-all duration-300 py-3.5 pl-4 pr-14 w-full border-gray-300 dark:bg-slate-800 dark:text-white/80 dark:border-slate-600 rounded-md text-base placeholder-gray-400 bg-white focus:ring disabled:cursor-not-allowed focus:border-blue-500 focus:ring-blue-500/20
          ${disabled ? '!bg-[#E5E7EB] !text-[#6B7280] !border-[#DFE4EA] !opacity-100 cursor-not-allowed' : 'bg-white text-black border-gray-300'}`}
        containerClassName="relative z-[100]"
        popoverDirection="down"
        asSingle
        startWeekOn='mon'
        displayFormat='DD.MM.YYYY'
        placeholder='дд.мм.гггг'
        readOnly={true}
        useRange={false}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        value={value}
        onChange={onChange}
        i18n='ru'
        configs={{
          shortcuts: russianLocale.shortcuts,
        }}
      />

      {description && <span className='text-xs'>{description}</span>}
    </div>
  );
}

export default InputDate;
